import { render, staticRenderFns } from "./UploadOssBlock.vue?vue&type=template&id=83e4ac24&scoped=true"
import script from "./UploadOssBlock.vue?vue&type=script&lang=js"
export * from "./UploadOssBlock.vue?vue&type=script&lang=js"
import style0 from "./UploadOssBlock.vue?vue&type=style&index=0&id=83e4ac24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e4ac24",
  null
  
)

export default component.exports